import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, CardTitle, EmptyState, StatusPill, Table, TableBody, TableCell, TableHead, TableHeaderCell, TableRow } from '@invested/ui';
import * as api from '../../services/api';
import type { Participant } from '../../types';
import { PARTICIPANT_STATUS_LABEL, PARTICIPANT_STATUS_TONE } from './statusLabels';

export function ParticipantsListPage() {
  const [participants, setParticipants] = useState<Participant[] | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api
      .getParticipants()
      .then(setParticipants)
      .catch(() => setError(true));
  }, []);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between gap-4">
        <div>
          <CardTitle as="h1">Deltakere</CardTitle>
          <p className="mt-1 text-sm text-black/55">{participants ? `${participants.length} deltakere registrert.` : 'Laster…'}</p>
        </div>
        <Link to="/deltakere/ny">
          <Button>Ny deltaker</Button>
        </Link>
      </div>

      {error && <EmptyState title="Fikk ikke lastet deltakerlisten" description="Prøv å laste siden på nytt." />}

      {participants && participants.length === 0 && (
        <EmptyState title="Ingen deltakere ennå" description="Registrer den første deltakeren for å komme i gang." />
      )}

      {participants && participants.length > 0 && (
        <Table>
          <TableHead>
            <TableRow>
              <TableHeaderCell>Pseudonym-ID</TableHeaderCell>
              <TableHeaderCell>Status</TableHeaderCell>
              <TableHeaderCell>Inkludert</TableHeaderCell>
              <TableHeaderCell>Alder</TableHeaderCell>
              <TableHeaderCell>Kjønn</TableHeaderCell>
              <TableHeaderCell>Prøver</TableHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {participants.map((p) => (
              <TableRow key={p.id}>
                <TableCell>
                  <Link className="font-medium text-[var(--brand-primary,#4338ca)] hover:underline" to={`/deltakere/${p.id}`}>
                    {p.pseudonymId}
                  </Link>
                </TableCell>
                <TableCell>
                  <StatusPill tone={PARTICIPANT_STATUS_TONE[p.status]}>{PARTICIPANT_STATUS_LABEL[p.status]}</StatusPill>
                </TableCell>
                <TableCell>{p.inclusionDate ? p.inclusionDate.slice(0, 10) : '—'}</TableCell>
                <TableCell>{p.ageYears ?? '—'}</TableCell>
                <TableCell>{p.sex ?? '—'}</TableCell>
                <TableCell>{p._count?.samples ?? 0}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
}
